import React, { useEffect, useState } from "react";
import { AccountState, FormItemType } from "./AccountForm.model";
import AccountForm from "./AccountForm";
import ChangeEmailForm from "./ChangeEmailForm";
import ChangePasswordForm from "./ChangePasswordForm";
import Loading from "@components/ui/loading";
import useHardwareSubscription from "@hooks/useHardwareSubscription";
import { useUserProfile } from "@providers/profile";

const AccountFormLayout = ({ isDigital }: { isDigital: boolean }) => {
  const hardwareSubscription = useHardwareSubscription();
  const {
    profileState: { profile, authToken },
  } = useUserProfile();
  const [accountState, setAccountState] = useState<AccountState>({
    editing: "default",
    error: null,
    loading: false,
    updated: "",
  });

  const renderSwitch = (status: FormItemType) => {
    switch (status) {
      case "email":
        return <ChangeEmailForm state={accountState} dispatchState={setAccountState} />;
      case "password":
        return <ChangePasswordForm state={accountState} dispatchState={setAccountState} />;
      default:
        return (
          <AccountForm
            isDigital={isDigital}
            state={accountState}
            dispatchState={setAccountState}
            subscription={hardwareSubscription}
          />
        );
    }
  };

  return (
    <>
      <article>{renderSwitch(accountState.editing)}</article>
      <Loading visible={accountState.loading} />
    </>
  );
};

export default AccountFormLayout;
